import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'UNIDADE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('unidadeForm', registro)
    ];
}

export function getLista(idEmpreendimento) {
    const request = axios.get(`${consts.API_URL}/unidade?id_empreendimento=${idEmpreendimento || 1}`);
    return {
        type: 'UNIDADE_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/unidade`, {
				...registro,
				leste: FormatUtils.formatarValorBanco(registro.leste || 0, 4),
				oeste: FormatUtils.formatarValorBanco(registro.oeste || 0, 4),
				norte: FormatUtils.formatarValorBanco(registro.norte || 0, 4),
				sul: FormatUtils.formatarValorBanco(registro.sul || 0, 4),
				area_privativa: FormatUtils.formatarValorBanco(registro.area_privativa || 0, 4),
				area_total: FormatUtils.formatarValorBanco(registro.area_total || 0, 4),
				preco_avista: FormatUtils.formatarValorBanco(registro.preco_avista, 2),
				preco_prazo: FormatUtils.formatarValorBanco(registro.preco_prazo, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_empreendimento));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/unidade`, {
				...registro,
				leste: FormatUtils.formatarValorBanco(registro.leste || 0, 4),
				oeste: FormatUtils.formatarValorBanco(registro.oeste || 0, 4),
				norte: FormatUtils.formatarValorBanco(registro.norte || 0, 4),
				sul: FormatUtils.formatarValorBanco(registro.sul || 0, 4),
				area_privativa: FormatUtils.formatarValorBanco(registro.area_privativa || 0, 4),
				area_total: FormatUtils.formatarValorBanco(registro.area_total || 0, 4),
				preco_avista: FormatUtils.formatarValorBanco(registro.preco_avista, 2),
				preco_prazo: FormatUtils.formatarValorBanco(registro.preco_prazo, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_empreendimento));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/unidade?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_empreendimento));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

//Reserva

export function initFormReserva(registro = {}) {
	console.log(registro);
    return [
        initialize('unidadeReservaForm', registro)
    ];
}

export function getListaReserva(idEmpreendimento) {
    const request = axios.get(`${consts.API_URL}/unidadeReserva/geral?id_empreendimento=${idEmpreendimento || 1}`);
    return {
        type: 'UNIDADE_RESERVA_LISTADO',
        payload: request
    };
}

export function salvarReserva(registro) {

    return (dispatch, getState) => {
		axios.post(`${consts.API_URL}/unidadeReserva`, {
			...registro,
			id_usuario_reserva: getState().auth.usuario.id,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			if (resp.data.quantidadeReservas > 1) {
				window.alert(`Reserva realizada com sucesso. Sua reserva é a ${resp.data.quantidadeReservas}ª da fila`);
			} else {
				window.alert(`Reserva realizada com sucesso. Sua reserva é a ${resp.data.quantidadeReservas}ª da fila`);
			}
			dispatch(getLista(registro.id_empreendimento));
			registro.evento();
		}).catch(e => {
			setErroAPI(e);
			dispatch(getLista(registro.id_empreendimento));
		});
    };
}

export function alterarReservaPerdida(registro) {

    return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/unidadeReserva/reservaPerdida`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('A reserva foi removida');
			dispatch(getListaReserva(registro.id_empreendimento || 1));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function alterarVenda(registro) {

    return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/unidadeReserva/venda`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('A venda foi confirmada');
			dispatch(getListaReserva(registro.id_empreendimento || 1));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function salvarSimulacao(registro) {

    return (dispatch, getState) => {
		axios.post(`${consts.API_URL}/unidadeSimulacao`, {
			...registro,
			nome_corretor: getState().auth.usuario.nome,
			creci: getState().auth.usuarioCarregado.creci,
			id_usuario_inclusao: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp =>  {
			const url = `${consts.URL}/${resp.data}`;
			if (window.confirm("Deseja realmente imprimir?")) {
				window.open(url, "_blank");
			}
		}).catch(e => {
			setErroAPI(e);
			dispatch(getLista(registro.id_empreendimento));
		});
    };
}